import * as React from "react"
import { Link } from "gatsby"

interface paramIf {
  children: string
  href: string
  outer?: boolean
  color: 'red' | 'green' | 'blue' | undefined
}

export default function Alice({ children, color, href, outer }: paramIf) {
  const colorName = (function (color) {
    if (color === 'blue') return 'bg-blue-700 hover:bg-blue-900 text-white font-bold py-4 px-6 rounded'
    if (color === 'green') return 'bg-green-700 hover:bg-green-900 text-white font-bold py-4 px-6 rounded'
    if (color === 'red') return 'bg-red-700 hover:bg-red-900 text-white font-bold py-4 px-6 rounded'
    return 'bg-blue-700 hover:bg-blue-900 text-white font-bold py-4 px-6 rounded'
  })(color)
  const target = outer ? '_blank' : '_self'
  if (target === '_self') {
    return (
      <div className="text-center btn my-6 whitespace-nowrap">
        <Link className={colorName} to={href}>
          {children}
        </Link>   
      </div>
    )
  } else {
    return (
      <div className="text-center btn my-6 whitespace-nowrap">
      <a className={colorName} href={href} target="_blank" rel="noopener noreferrer">
        {children}
      </a>   
    </div>
    )
  }

}
